module.exports = arr => arr[arr.length - 1]
